var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16688 1.25006C3.70664 1.25006 3.33355 1.62316 3.33355 2.08339V6.25006H1.67658C1.6598 6.24988 1.64303 6.2502 1.62629 6.25103C1.50215 6.25697 1.38513 6.29008 1.28105 6.34454C1.19335 6.39026 1.11271 6.45224 1.04394 6.5298C0.913207 6.67679 0.833719 6.87036 0.833496 7.0825V17.9167C0.833496 18.377 1.20659 18.7501 1.66683 18.7501H18.3335C18.7937 18.7501 19.1668 18.377 19.1668 17.9167V7.09557C19.1687 6.97037 19.1426 6.84406 19.0869 6.72674C19.0782 6.70836 19.0687 6.69021 19.0585 6.67232C19.039 6.63789 19.017 6.60498 18.9929 6.57383C18.9105 6.46703 18.807 6.38568 18.6927 6.33123C18.5969 6.28541 18.491 6.25734 18.3792 6.2513C18.3608 6.25027 18.3423 6.24986 18.3238 6.25006H16.6669V2.08339C16.6669 1.62316 16.2938 1.25006 15.8335 1.25006H4.16688ZM2.50016 17.0834V8.75002L9.50021 14.0001C9.79651 14.2223 10.2039 14.2223 10.5002 14.0001L17.5002 8.7501V17.0834H2.50016ZM10.8335 5.00006C10.8335 4.53982 10.4604 4.16673 10.0002 4.16673C9.53993 4.16673 9.16683 4.53982 9.16683 5.00006V7.57155L8.50608 6.91081C8.18065 6.58537 7.65301 6.58537 7.32757 6.91081C7.00214 7.23624 7.00214 7.76388 7.32757 8.08932L9.41066 10.1724L9.41268 10.1744C9.49216 10.2534 9.58361 10.3131 9.68118 10.3535C9.77943 10.3942 9.88717 10.4167 10.0002 10.4167C10.1132 10.4167 10.2209 10.3942 10.3191 10.3535C10.4167 10.3131 10.5082 10.2534 10.5876 10.1744L10.5894 10.1726L12.6728 8.08932C12.9982 7.76388 12.9982 7.23624 12.6728 6.91081C12.3473 6.58537 11.8197 6.58537 11.4942 6.91081L10.8335 7.57155V5.00006Z",
    fill: "url(#paint0_linear_4627_1304)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4627_1304",
    x1: 10.0002,
    y1: 1.25006,
    x2: 10.0002,
    y2: 18.7501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527BF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41A0E5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailDownload);
export default __webpack_public_path__ + "static/media/mail-download.356efed410363c7d23fce825cbfa5cd3.svg";
export { ForwardRef as ReactComponent };